export enum CapitalModules {
  CapitalRoutesStripeSplitFunding = 'capital.routes.stripe_split_funding',
}

export enum CapitalTrackingEvents {
  CapitalBannerViewed = 'Capital Banner Viewed',
  CapitalBannerClicked = 'Capital Banner Clicked',
}

export enum CapitalBannerLocations {
  Top = 'top',
  Middle = 'middle',
  Bottom = 'bottom',
}

export enum CapitalBannerVersions {
  V1 = 'v1',
  V2 = 'v2',
  Backbook = 'backbook',
}

export enum CapitalOfferTags {
  Backbook = 'backbook',
}
